var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{attrs:{"lat-lng":_vm.item.geopoints,"zIndexOffset":1}},[_c('l-icon',{attrs:{"icon-size":_vm.iconSize(),"icon-anchor":_vm.iconAnchor()}},[_c('div',{staticClass:"icon-stop",style:(_vm.iconStyle())})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }